interface ColorPickerFieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
}

export function ColorPickerField({ label, value, onChange }: ColorPickerFieldProps) {
  return (
    <div className="flex items-center gap-3">
      <input
        type="color"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="h-10 w-12 shrink-0 cursor-pointer rounded-lg border border-border-default bg-transparent p-0.5"
      />
      <div className="flex-1">
        <label className="block text-xs font-medium text-text-secondary mb-1">{label}</label>
        <input
          type="text"
          value={value}
          onChange={(e) => {
            const v = e.target.value;
            if (/^#[0-9a-fA-F]{0,6}$/.test(v)) onChange(v);
          }}
          className="w-full rounded-lg border border-border-default bg-bg-field px-2.5 py-1.5 text-xs font-mono text-text-primary outline-none focus:border-accent"
          dir="ltr"
        />
      </div>
    </div>
  );
}
